import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DashboardComponent } from "./dashboard.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { IndexComponent } from "./pages/index/index.component";
import { LogoutComponent } from "./pages/logout/logout.component";
import { AuthGuard } from "./guard/auth.guard";
import { InvalidAuthComponent } from "./pages/invalid-auth/invalid-auth.component";
import { DashboardPageNotFoundComponent } from "./pages/dashboard-page-not-found/dashboard-page-not-found.component";
import { UserProfileComponent } from "./pages/profile/user-profile/user-profile.component";
import { AccountVerificationComponent } from "./pages/profile/account-verification/account-verification.component";
import { TradeExperienceComponent } from "./pages/profile/trade-experience/trade-experience.component";
import { DocumentVerificationComponent } from "./pages/profile/document-verification/document-verification.component";
import { ChangePasswordComponent } from "./pages/profile/change-password/change-password.component";
import { NotificationSettingsComponent } from "./pages/profile/notification-settings/notification-settings.component";
import { AccountSecurityComponent } from "./pages/profile/account-security/account-security.component";
import { AccountsComponent } from "./pages/accounts/accounts.component";
import { DemoComponent } from "./pages/accounts/demo/demo.component";
import { LiveComponent } from "./pages/accounts/live/live.component";
import { FinanceComponent } from "./pages/finance/finance.component";
import { DepositComponent } from "./pages/finance/deposit/deposit.component";
import { WithdrawComponent } from "./pages/finance/withdraw/withdraw.component";
import { InternalTransferComponent } from "./pages/finance/internal-transfer/internal-transfer.component";
import { ToolsComponent } from "./pages/tools/tools.component";
import { EconomicCalendarComponent } from "./pages/tools/economic-calendar/economic-calendar.component";
import { DepositReportComponent } from "./pages/finance/report/deposit-report/deposit-report.component";
import { WithdrawReportComponent } from "./pages/finance/report/withdraw-report/withdraw-report.component";
import { InternalTransferReportComponent } from "./pages/finance/report/internal-transfer-report/internal-transfer-report.component";
import { UserBankAccountComponent } from "./pages/profile/user-bank-account/user-bank-account.component";

const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: "", component: IndexComponent },
      {
        path: "profile",
        component: ProfileComponent,
        children: [
          { path: "", redirectTo: "user", pathMatch: "full" },
          { path: "user", component: UserProfileComponent },
          {
            path: "account-verification",
            component: AccountVerificationComponent,
          },
          { path: "trading-experience", component: TradeExperienceComponent },
          {
            path: "document-verification",
            component: DocumentVerificationComponent,
          },
          { path: "change-password", component: ChangePasswordComponent },
          {
            path: "notification-settings",
            component: NotificationSettingsComponent,
          },
          { path: "account-security", component: AccountSecurityComponent },
        ],
      },
      {
        path: "accounts",
        component: AccountsComponent,
        children: [
          { path: "", redirectTo: "demo", pathMatch: "full" },
          { path: "demo", component: DemoComponent },
          { path: "live", component: LiveComponent },
        ],
      },
      {
        path: "finance",
        component: FinanceComponent,
        children: [
          { path: "", redirectTo: "deposit", pathMatch: "full" },
          { path: "deposit", component: DepositComponent },
          { path: "withdraw", component: WithdrawComponent },
          { path: "internal-transfer", component: InternalTransferComponent },
          { path: "deposit-report", component: DepositReportComponent },
          { path: "withdraw-report", component: WithdrawReportComponent },
          {
            path: "internal-transfer-report",
            component: InternalTransferReportComponent,
          },
        ],
      },
      { path: "documents", redirectTo: "profile/document-verification" },
      { path: "user-bank-account", component: UserBankAccountComponent },      
      {
        path: "tools",
        component: ToolsComponent,
        children: [
          { path: "economic-calendar", component: EconomicCalendarComponent },
        ],
      },
      { path: "401", component: InvalidAuthComponent },
      { path: "404", component: DashboardPageNotFoundComponent },
      { path: "logout", component: LogoutComponent },
      { path: "**", redirectTo: "404" },
    ],
  },
  { path: "**", redirectTo: "404" },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DasboardRoutingModule { }
